<template>
  <div class="sidebar" style="display:none">
    <div class="sidebar-cont">
      <h4 class="sidebar-h">Announcements</h4>
      <p>
        Coming Soon!. This is where you will find all your workshop links and
        other notifications from Upskill.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sideBar',
}
</script>

<style scoped>
.sidebar {
  height: 400px;
  background-color: white;
  margin-top: 3em;
  border-radius: 10px;
}
.sidebar-cont {
  padding: 2em;
}
.sidebar-h {
  font-weight: 600;
}
</style>
